import State from "../state"

export const message = (state: State) => state.message.message
export const values = (state: State) => state.message.values
